import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../utils/api";
import { showToast } from "./toastSlice";

const initialState = {
  list: [],
};

// Driver List
export const getdriverList = createAsyncThunk(
  "driver/get_list",
  async ({ hidePageLoader }, { dispatch }) => {
    try {
      const res = await api("get", "/driver");
      if (res.success && res.data) {
        dispatch(driverSlice.actions.setDriverList(res.data));
        return res.data;
      } else {
        dispatch(driverSlice.actions.setDriverList(res.data));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
        hidePageLoader(dispatch);
    }
  }
);

const driverSlice = createSlice({
  name: "driver",
  initialState,
  reducers: {
    setDriverList: (state, action) => {
      state.list = action.payload;
    },
  },
});

export const { setDriverList } = driverSlice.actions;

export default driverSlice.reducer;
